import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getMonthName',
  standalone: true
})
export class GetMonthNamePipe implements PipeTransform {
  private monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  transform(value: number): string {
    if (value >= 1 && value <= 12) {
      return this.monthNames[value - 1];
    }
    return '';
  }
}
